import React from 'react';
import { FramedAvatar } from '@/components/ui/FramedAvatar';
import { getInitials } from '@/utils/avatarUtils';

export interface PartnerInfo {
  id: string;
  name: string;
  profilePictureUrl?: string;
  beltRank?: string;
  trainingCount: number;
}

export interface PartnerCardProps {
  partner?: PartnerInfo | null;
  isEmpty?: boolean;
  emptyMessage?: string;
  className?: string;
}

const PartnerCard: React.FC<PartnerCardProps> = ({
  partner,
  isEmpty = false,
  emptyMessage = "Tag your partners on your trainings to discover who you roll the most",
  className = ""
}) => {
  if (isEmpty || !partner) {
    return (
      <div className={`flex flex-col items-center justify-center h-full w-full ${className}`}>
        {/* Zero Data State - Belt Icon with Question Mark */}
        <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center mb-2">
          <span className="text-white text-lg font-bold">?</span>
        </div>
        <p className="text-[10px] text-gray-400 text-center leading-tight px-1">
          {emptyMessage}
        </p>
      </div>
    );
  }

  return (
    <div className={`flex flex-col items-center justify-center h-full w-full ${className}`}>
      {/* Filled State - Partner Info */}
      <FramedAvatar
        src={partner.profilePictureUrl}
        initials={getInitials(partner.name)}
        size={28}
        frameSize={{ w: 36, h: 40 }}
        beltRank={partner.beltRank}
        className="mb-2"
      />
      <p className="text-[10px] text-white text-center font-medium mb-1 leading-tight truncate w-full px-1" title={partner.name}>
        {partner.name}
      </p>
      <p className="text-[8px] text-gray-400 text-center leading-tight">
        {partner.trainingCount} trainings together!
      </p>
    </div>
  );
};

export default PartnerCard;
